/* =============================================
   Product Item Collection Cards — Global Handler
   suver.cl
   ============================================= */
(function () {
  'use strict';

  function initCard(card) {
    var container = card.querySelector('.pi-variants');
    if (!container || container.dataset.piInit) return;
    container.dataset.piInit = '1';

    var variants = [];
    try { variants = JSON.parse(container.querySelector('.pi-variants-json').textContent); } catch (e) { return; }

    // Venta por metro: aunque la política Shopify sea "continue" (necesaria para
    // el retiro en tienda), una variante con 0 metros se trata como agotada.
    var ppmPaso = parseInt(container.getAttribute('data-ppm-roll'), 10) || 0;
    var ppmBase = ppmPaso >= 10 ? ppmPaso : 10;
    if (ppmPaso < 10) {
      // Venta por metro puro: el paso real (tramo_metros) viene en el step del input de la tarjeta
      var ppmStepInput = container.querySelector('.pi-qty-input');
      var ppmStep = ppmStepInput ? parseInt(ppmStepInput.step, 10) : 0;
      if (ppmStep >= 10) ppmBase = ppmStep;
    }
    if (container.getAttribute('data-ppm-strict') === '1') {
      variants.forEach(function (v) {
        if (v.inventory_management && (v.inventory_quantity || 0) < ppmBase) v.available = false;
      });
    }

    var chipsLists = container.querySelectorAll('.pi-chips-list');
    var selections = {};
    var productUrl = card.dataset.productUrl || '';

    // Pre-select first chip per list
    chipsLists.forEach(function (list) {
      var idx = parseInt(list.getAttribute('data-index'), 10);
      var first = list.querySelector('.pi-chip');
      if (first) { selections[idx] = first.dataset.value; first.classList.add('is-selected'); }
    });

    /* ---------- Variant helpers ---------- */

    function findVariant() {
      return variants.find(function (v) {
        for (var i = 0; i < v.options.length; i++) {
          if (selections[i] && v.options[i] != selections[i]) return false;
        }
        return true;
      }) || null;
    }

    function refreshChips() {
      chipsLists.forEach(function (list) {
        var idx = parseInt(list.getAttribute('data-index'), 10);
        list.querySelectorAll('.pi-chip').forEach(function (chip) {
          var val = chip.dataset.value;
          var ok = variants.some(function (v) {
            if (v.options[idx] != val) return false;
            for (var i = 0; i < v.options.length; i++) {
              if (i === idx) continue;
              if (selections[i] && v.options[i] != selections[i]) return false;
            }
            return v.available === true;
          });
          chip.classList.toggle('is-oos', !ok);
        });
      });
    }

    function applyVariantToUI(variant) {
      if (!variant) return;
      variant.options.forEach(function (val, idx) {
        selections[idx] = val;
        var list = container.querySelector('.pi-chips-list[data-index="' + idx + '"]');
        if (list) {
          list.querySelectorAll('.pi-chip').forEach(function (c) {
            c.classList.toggle('is-selected', c.dataset.value === val);
          });
        }
      });
    }

    /* ---------- UI refs ---------- */

    var priceEl  = container.querySelector('[data-pi-current-price]');
    var stockEl  = container.querySelector('[data-pi-stock]');
    var idInput  = container.querySelector('[data-pi-variant-id]');
    var viewBtn  = container.querySelector('[data-pi-view]');
    var moneyFmt = container.getAttribute('data-money-format')
                || (window.Shopify && window.Shopify.money_format)
                || '${{amount}}';

    function fmtMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, moneyFmt);
      return '$' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function updateUI() {
      var v = findVariant();
      var addBtn = container.querySelector('.pi-add-btn--primary');

      if (!v) {
        if (priceEl) priceEl.textContent = '—';
        if (stockEl) stockEl.innerHTML = '<span class="pi-dot pi-dot--oos"></span> Agotado';
        if (idInput) idInput.value = '';
        if (viewBtn) viewBtn.setAttribute('href', productUrl);
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        return;
      }

      if (priceEl) priceEl.textContent = fmtMoney(ppmPaso >= 10 ? v.price * ppmPaso : v.price);

      if (stockEl) {
        if (v.available) {
          if (v.inventory_management && v.inventory_policy !== 'continue') {
            var q = v.inventory_quantity || 0;
            var stockTxt;
            if (ppmPaso >= 10) { var rq = Math.floor(q / ppmPaso); stockTxt = rq + (rq === 1 ? ' rollo disponible' : ' rollos disponibles'); }
            else if (container.getAttribute('data-ppm-strict') === '1') { var qf = Math.floor(q / ppmBase) * ppmBase; stockTxt = qf + ' metros disponibles'; }
            else { stockTxt = q + ' disponibles'; }
            stockEl.innerHTML = '<span class="pi-dot" style="background:var(--success,#16a34a)"></span> <span style="color:var(--success,#16a34a)">' + stockTxt + '</span>';
          } else {
            stockEl.innerHTML = '<span class="pi-dot" style="background:var(--success,#16a34a)"></span> En stock';
          }
        } else {
          stockEl.innerHTML = '<span class="pi-dot pi-dot--oos"></span> Agotado';
        }
      }

      if (idInput) idInput.value = v.id;

      // Venta por metro: tope de compra = stock redondeado a múltiplo de 10 hacia abajo
      if (container.getAttribute('data-ppm-strict') === '1' && v.inventory_management) {
        var capInput = container.querySelector('.pi-qty-input');
        if (capInput) {
          var cap = Math.floor((v.inventory_quantity || 0) / ppmBase) * ppmBase;
          capInput.max = cap;
          var cur = parseInt(capInput.value, 10) || 0;
          var minCap = parseInt(capInput.min, 10) || 1;
          if (cap >= minCap && cur > cap) capInput.value = cap;
          var rollEl3 = container.querySelector('.pi-qty [data-ppm-roll-label]');
          if (rollEl3) { var r3 = Math.round((parseInt(capInput.value, 10) || 0) / ppmBase); rollEl3.textContent = r3 + (r3 === 1 ? ' rollo' : ' rollos'); }
        }
      }
      if (viewBtn) viewBtn.setAttribute('href', v.url);
      if (addBtn) { v.available ? addBtn.removeAttribute('disabled') : addBtn.setAttribute('disabled', 'disabled'); }
    }

    /* ---------- Mini-cart integration ---------- */

    function openOrRefreshMiniCart(cart, added) {
      try {
        if (cart && typeof cart.item_count !== 'undefined') {
          document.querySelectorAll('[data-cart-count], .header__cart-count, .cart-count-bubble')
            .forEach(function (el) { el.textContent = cart.item_count; });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh',  { detail: { cart: cart, added: added } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart, added: added } }));
        document.dispatchEvent(new CustomEvent('product:added', { detail: { cart: cart, added: added } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:open',    { detail: { cart: cart } }));

        var trigger = document.querySelector(
          '[data-action="open-cart"],[data-action="open-mini-cart"],[data-open-cart],' +
          '.js-cart-toggle,[aria-controls="modal-cart"],[aria-controls="mini-cart"],' +
          '[data-secondary-action="open-cart"]'
        );
        if (trigger) trigger.click();

        var tries = 0;
        (function locatePanel() {
          tries++;
          var panel = document.querySelector(
            '[data-cart-drawer], .mini-cart, #mini-cart, .drawer--cart,' +
            ' [aria-modal="true"][id*="cart"], .cart-popup, .modal--cart'
          );
          if (panel) {
            if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
            panel.focus({ preventScroll: true });
            var rect = panel.getBoundingClientRect();
            if (rect.top < 0 || rect.top >= window.innerHeight * 0.85) {
              panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            return;
          }
          if (tries < 10) setTimeout(locatePanel, 100);
          else window.scrollTo({ top: 0, behavior: 'smooth' });
        })();
      } catch (e) { /* silent */ }
    }

    /* ---------- Event: chip click ---------- */

    container.addEventListener('click', function (ev) {
      var chip = ev.target.closest('.pi-chip');
      if (chip) {
        if (chip.classList.contains('is-oos')) return;
        var list = chip.closest('.pi-chips-list');
        var idx = parseInt(list.getAttribute('data-index'), 10);
        list.querySelectorAll('.pi-chip').forEach(function (c) { c.classList.remove('is-selected'); });
        chip.classList.add('is-selected');
        selections[idx] = chip.dataset.value;
        refreshChips();
        updateUI();
        return;
      }

      var toggleBtn = ev.target.closest('[data-action="toggle-more"]');
      if (toggleBtn) {
        var prevList = toggleBtn.previousElementSibling;
        if (prevList && prevList.classList.contains('pi-chips-list')) {
          var collapsed = prevList.classList.contains('is-collapsed');
          if (collapsed) {
            prevList.classList.remove('is-collapsed');
            toggleBtn.textContent = toggleBtn.dataset.labelLess || 'Ver menos';
            toggleBtn.setAttribute('aria-expanded', 'true');
          } else {
            prevList.classList.add('is-collapsed');
            toggleBtn.textContent = toggleBtn.dataset.labelMore || 'Ver más';
            toggleBtn.setAttribute('aria-expanded', 'false');
          }
        }
      }
    });

    /* ---------- Event: quantity buttons ---------- */

    var qtyWrap = container.querySelector('.pi-qty');
    if (qtyWrap) {
      qtyWrap.addEventListener('click', function (e) {
        var b = e.target.closest('.pi-qty-btn');
        if (!b) return;
        var delta = parseInt(b.getAttribute('data-qty'), 10) || 0;
        var input = qtyWrap.querySelector('.pi-qty-input');
        var minv = parseInt(input.min, 10) || 1;
        var val = parseInt(input.value, 10) || minv;
        var nv = Math.max(minv, val + delta);
        var maxv = parseInt(input.max, 10);
        if (!isNaN(maxv) && maxv >= minv) nv = Math.min(nv, maxv);
        input.value = nv;
        var rollEl = qtyWrap.querySelector('[data-ppm-roll-label]');
        if (rollEl) { var rp = parseInt(container.getAttribute('data-ppm-roll'), 10) || 10; var r = Math.round(nv / rp); rollEl.textContent = r + (r === 1 ? ' rollo' : ' rollos'); }
      });
      var qInput = qtyWrap.querySelector('.pi-qty-input');
      if (qInput) {
        qInput.addEventListener('change', function () {
          var step = parseInt(qInput.step, 10) || 1;
          var minv = parseInt(qInput.min, 10) || 1;
          var val = parseInt(qInput.value, 10);
          if (isNaN(val)) val = minv;
          if (step > 1) val = Math.round(val / step) * step;
          val = Math.max(minv, val);
          var maxv2 = parseInt(qInput.max, 10);
          if (!isNaN(maxv2) && maxv2 >= minv) val = Math.min(val, Math.floor(maxv2 / step) * step);
          qInput.value = val;
          var rollEl2 = qtyWrap.querySelector('[data-ppm-roll-label]');
          if (rollEl2) { var rp2 = parseInt(container.getAttribute('data-ppm-roll'), 10) || 10; var r2 = Math.round(val / rp2); rollEl2.textContent = r2 + (r2 === 1 ? ' rollo' : ' rollos'); }
        });
      }
    }

    /* ---------- Event: AJAX add-to-cart ---------- */

    var form = container.querySelector('[data-ajax-add]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vId = idInput ? idInput.value : '';
        if (!vId) return;

        var addBtn = container.querySelector('.pi-add-btn--primary');
        if (addBtn) {
          addBtn.classList.add('is-loading');
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.setAttribute('aria-busy', 'true');
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
        .then(function (r) { if (!r.ok) throw new Error('add-failed'); return r.json(); })
        .then(function (added) {
          // Success feedback
          if (addBtn) {
            addBtn.classList.remove('is-loading');
            addBtn.classList.add('is-success');
            var textEl = addBtn.querySelector('.pi-add-text');
            var orig = textEl ? textEl.textContent : '';
            if (textEl) textEl.textContent = '✓ Agregado';
            setTimeout(function () {
              addBtn.classList.remove('is-success');
              if (textEl) textEl.textContent = orig;
            }, 1800);
          }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { openOrRefreshMiniCart(cart, added); });
        })
        .catch(function (err) { console.warn('pi-collection: add-to-cart error', err); })
        .finally(function () {
          if (addBtn) {
            addBtn.classList.remove('is-loading');
            addBtn.removeAttribute('aria-busy');
            addBtn.removeAttribute('disabled');
          }
        });
      });
    }

    /* ---------- Init: ensure first available variant ---------- */

    refreshChips();
    var current = findVariant();
    if (!current || !current.available) {
      var firstAvail = variants.find(function (x) { return x && x.available; });
      if (firstAvail) {
        applyVariantToUI(firstAvail);
        refreshChips();
      }
    }
    updateUI();

    /* ---------- D+: Auto-collapse long chip lists (desktop only) ---------- */
    if (window.innerWidth >= 641) {
      var MAX_VISIBLE_CHIPS = 3;
      chipsLists.forEach(function (list) {
        var chips = list.querySelectorAll('.pi-chip-wrap');
        if (chips.length > MAX_VISIBLE_CHIPS) {
          var hiddenCount = chips.length - MAX_VISIBLE_CHIPS;
          list.classList.add('is-collapsed');

          var moreBtn = document.createElement('button');
          moreBtn.type = 'button';
          moreBtn.className = 'pi-chip--more';
          moreBtn.textContent = '+' + hiddenCount + ' más';
          moreBtn.dataset.action = 'toggle-more';
          moreBtn.dataset.labelMore = '+' + hiddenCount + ' más';
          moreBtn.dataset.labelLess = 'Ver menos';
          moreBtn.setAttribute('aria-expanded', 'false');
          list.parentNode.insertBefore(moreBtn, list.nextSibling);
        }
      });
    }
  }

  /* ========== Bootstrap ========== */

  function initAll() {
    // Restore pi-card class if theme's layout switcher stripped it
    document.querySelectorAll('.product-item[data-product-url] .pi-variants').forEach(function (v) {
      var card = v.closest('.product-item');
      if (card && !card.classList.contains('pi-card')) {
        card.classList.add('pi-card');
      }
    });

    document.querySelectorAll('.pi-card:not([data-pi-ready])').forEach(function (card) {
      card.setAttribute('data-pi-ready', '1');
      initCard(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after theme AJAX reloads (sort, filter, pagination)
  document.addEventListener('theme:loading:end', function () {
    setTimeout(initAll, 50);
  });

  // Expose for AJAX pagination or dynamic content
  window.initPiCards = initAll;
})();
